import { Link } from "react-router-dom";
import { Users, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { IMG } from "@/data/site";
import { Reveal, Eyebrow } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function Dining() {
  const { t, lang } = useLang();
  const d = t.diningPage;

  return (
    <div data-testid="dining-page" key={lang} className="pt-16 sm:pt-20">
      <Seo title={t.seo.dining.title} description={t.seo.dining.desc} />

      <header className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-14 sm:pt-20 pb-12">
        <Reveal>
          <Eyebrow>Sobe Bevanda — Međugorje</Eyebrow>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1F2421]">{d.title}</h1>
          <p className="text-lg sm:text-xl text-[#4A504B] font-light leading-relaxed mt-6 max-w-2xl">{d.lead}</p>
        </Reveal>
      </header>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <div className="overflow-hidden rounded-2xl">
            <img src={IMG.diningA} alt="Dining room at Sobe Bevanda" className="w-full aspect-[16/8] object-cover" />
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-5">
          <h2 className="font-serif-display text-3xl sm:text-4xl text-[#1F2421] leading-snug">{t.diningPreview.title}</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7 space-y-6">
          <p className="text-base sm:text-lg text-[#4A504B] leading-relaxed">{d.body1}</p>
          <p className="text-base sm:text-lg text-[#4A504B] leading-relaxed">{d.body2}</p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {[IMG.diningB, IMG.diningC, IMG.breakfast].map((src, i) => (
            <Reveal key={src} delay={i * 0.08}>
              <div className="overflow-hidden rounded-xl">
                <img src={src} alt="Dining at Sobe Bevanda" loading="lazy" className="w-full aspect-[4/5] object-cover hover:scale-[1.04] transition-transform duration-700" />
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section data-testid="dining-group-cta" className="bg-[#F3EFE6] py-16 sm:py-20 mb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 flex flex-col md:flex-row md:items-center justify-between gap-8">
          <Reveal>
            <div className="flex items-center gap-4">
              <Users size={26} strokeWidth={1.5} className="text-[#4A5D3E] shrink-0" />
              <h2 className="font-serif-display text-3xl sm:text-4xl text-[#1F2421]">{d.ctaTitle}</h2>
            </div>
            <p className="text-[#4A504B] mt-4 max-w-xl">{d.ctaText}</p>
          </Reveal>
          <Reveal delay={0.12}>
            <Link
              to="/kontakt"
              data-testid="dining-inquiry-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-[#4A5D3E] hover:bg-[#3A4A31] text-[#F9F8F3] text-sm font-semibold px-7 py-3.5 transition-colors duration-300"
            >
              {t.cta.sendInquiry}
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
